<template>
    <header>
        <!-- 页头 -->
        <van-nav-bar
            title="Ningbo Globalway Imp. & Exp. Co., Ltd."
            style="z-index: 10000"
            left-arrow
            @click-left="clickLogo"
        >
            <template #left>
                <img src="../../public/img/globalway_black.png" width="70%" alt="logo">
            </template>
            <template #right>
                <van-icon color="#242424" name="search" @click="searchProduct"/>
                <van-icon v-if="!menuShow" color="#242424" name="wap-nav" @click="menuShow = true"/>
                <van-icon v-else color="#242424" name="cross" @click="closeMenu"/>
            </template>
        </van-nav-bar>
        <!-- 菜单栏 -->
        <div class="menu" :class="{active: menuShow}">
            <div class="page one" :class="{active: menuType === 0}">
                <div class="title">
                    <b>Globalway&nbsp;&nbsp;&nbsp;Hooya&nbsp;Group</b>
                </div>
                <van-list class="list">
                    <van-cell title="HOME" @click="jumpToPage('/')"/>
                    <van-cell title="ABOUT US" @click="jumpToPage('/aboutus')"/>
                    <van-cell title="PRODUCTS" is-link @click="menuType = 1"/>
                    <van-cell title="PARTNERS" @click="jumpToPage('/partners')"/>
                    <van-cell title="FAIR & SHOW" @click="jumpToPage('/exhibition')"/>
                    <van-cell title="CONTACT US" @click="jumpToPage('/contactus')"/>
                </van-list>
            </div>
            <div class="page two" id="eventstop" :class="{active: menuType === 1}" @click="clickCatelog">
                <div class="title" @click="menuType = 0">
                    <van-icon name="arrow-left"/>
                </div>
                <van-collapse v-model="firstLevelMenu" id="productList" accordion style="overflow: auto;max-height: calc(414px - 10rem)">
                    <van-collapse-item v-for="(item, key) in $store.state.catalog" :key="key" :title="item.title" :name="item.title">
                        <template #icon>
                            <van-image width="1rem" height="1rem" :src="item.icon" />
                        </template>
                        <van-cell :title="i.title" v-for="(i, index) in item.children" :elid="i.id" :key="index"/>
                    </van-collapse-item>
                </van-collapse>
            </div>
            <div class="more" :class="{active: notBottom && menuType === 1}"><van-icon name="arrow-down" /></div>
        </div>

        <!-- 搜索框 -->
        <div class="search-box" ref="searchBox">
            <van-form @submit="onSubmit">
                <van-field
                    v-model="searchValue"
                    left-icon="search"
                    placeholder="Search product"
                    ref="searchInput"
                >
                    <template #button>
                        <van-icon name="cross" @click="closeSearch"/>
                    </template>
                </van-field>
            </van-form>
        </div>
        
        <!-- 遮罩 -->
        <div
            class="mask"
            @click="menuShow = false"
            :style="{height: menuShow ? '100vh' : '0vh'}">
        </div>
    </header>
</template>

<script>
import {
    NavBar as VanNavBar,
    Icon as VanIcon,
    List as VanList,
    Cell as VanCell,
    Collapse as VanCollapse,
    CollapseItem as VanCollapseItem,
    Image as VanImage,
    Field as VanField,
    Form as VanForm
} from 'vant';

export default {
    name: 'Header',
    data() {
        return {
            menuShow: false,        // 菜单显示
            menuType: 0,            // 0-总菜单，1-产品菜单
            firstLevelMenu: '',     // 一级菜单
            menuList: [
                // {
                //     title: "Houseware",
                //     icon: "http://www.globalwayhome.com/Upload/Alibaba/202108101914367597/%E6%9C%AA%E6%A0%87%E9%A2%98-3-01.png",
                //     children: [
                //         {title: "Aluminum", id: "98012374"},
                //         {title: "Mousse Ring", id: "gnbng80dsd891hds"}
                //     ]
                // }, {
                //     title: "As",
                //     icon: "http://www.globalwayhome.com/Upload/Alibaba/202108101914367597/%E6%9C%AA%E6%A0%87%E9%A2%98-3-01.png",
                //     children: [
                //         {title: "Aluminum", id: "431280xcas891hds"},
                //         {title: "Mousse Ring", id: "cwe1237891hds"}
                //     ]
                // }
            ],
            searchValue: "",
            notBottom: true,
        }
    },
    mounted() {
        const productList = document.getElementById('productList');
        productList.addEventListener('scroll', () => {
            if (productList.scrollHeight - productList.scrollTop === productList.clientHeight) {
                this.notBottom = false;
            } else {
                this.notBottom = true;
            }
        })
    },
    methods: {
        onSubmit() {
            this.$router.push(`/products?keyword=${this.searchValue}`);
            this.$refs.searchBox.classList.remove('active');
        },
        closeSearch() {
            this.searchValue = "";
            this.$refs.searchBox.classList.remove('active');
        },
        jumpToPage(address) {
            this.closeMenu();
            this.$router.push(address);
        },
        closeMenu() {
            this.menuShow = false
            setTimeout(() => this.menuType = 0, 200)
        },
        clickLogo() {
            this.$router.push('/')
        },
        searchProduct() {
            this.closeMenu();
            this.$refs.searchInput.focus();
            this.$refs.searchBox.classList.add('active');
        },
        clickCatelog(ev) {
            const event = ev || window.event
            const target = event.target || event.srcElement

            const getEl = el => {
                if (!el) return
                if (el.className === 'van-collapse-item van-collapse-item--border') return

                if (el.attributes && el.attributes.elid) {
                    this.$router.push(`/products?id=${el.attributes.elid.value}`);
                    this.menuShow = false;
                    this.$store.commit('setCatalogName', `${this.firstLevelMenu}|${el.innerText}`)
                } else {
                    getEl(el.parentNode)
                }
            }
            getEl(target)
        }
    },
    components: { VanIcon, VanNavBar, VanList, VanCell, VanCollapse, VanCollapseItem, VanImage, VanField, VanForm }
}
</script>

<style lang="less" scoped>
    header { position: fixed; top: 0; left: 0; width: 100%; z-index: 10000; box-shadow: 0 3px 3px 0px #0000004d; }
    .mask { position: fixed; top: 0; bottom: 0; left: 0; right: 0; transition: .2 all ease; background-color: #00000099; z-index: 999; }

    .menu { max-height: 0; transition: .2s all ease; background-color: #fff; overflow: hidden; position: absolute; width: 100%; z-index: 1000; }
    .menu.active { max-height: 400px; box-shadow: 0 3px 3px 0px #0000004d; }
    .menu .page { top: 0; transition: .2s all ease; }
    .menu .page.one { position: relative; left: -100%; }
    .menu .page.one.active { left: 0; }
    .menu .page.two { position: absolute; top: 0; width: 100%; right: -100%; }
    .menu .page.two.active { right: 0; }
    .menu .page .title { font-size: 1rem; line-height: 3rem; padding-left: 1rem; border-bottom: 1px solid #f1f2f3; background-color: #f6f6f6; }
    .menu .page .title i { font-weight: 700; vertical-align: text-top; }
    .menu .more { position: absolute; bottom: -100%; left: 0; text-align: center; width: 100%; background: #FFF; line-height: 1.5rem; transition: .4s all ease; }
    .menu .more.active { bottom: 0; }

    .search-box { height: 3.4rem; width: 100%; position: absolute; top: -3.4rem; z-index: 10010; background-color: #fff; transition: .2s all ease; }
    .search-box.active { top: 0; }
    /deep/ .search-box .van-cell { font-size: 18px; position: absolute; top: 50%; transform: translateY(-50%); }
    /deep/ .search-box .van-icon { font-size: 26px; vertical-align: bottom; }

    /deep/ .van-nav-bar .van-nav-bar__title { max-width: 58%; font-size: .8rem; font-weight: 700; }
    /deep/ .van-image { padding-right: 1rem; }
    /deep/ .van-image__img { display: inline-block; vertical-align: text-bottom; }
    /deep/ .van-collapse-item__content { padding: 0; }
    /deep/ .van-collapse-item__content .van-cell { padding-left: 3rem; }
    /deep/ .van-nav-bar__content { height: 3.4rem; }
    /deep/ .van-nav-bar__right { font-size: 2.125rem; }
    /deep/ .van-nav-bar__title { max-width: 50%; }
    /deep/ .van-nav-bar__left,
    /deep/ .van-nav-bar__right { padding: 0 10px; }
    /deep/ .van-nav-bar__left:active,
    /deep/ .van-nav-bar__right:active { opacity: 1; }
    /deep/ .van-hairline--top-bottom:after { border-width: 0px; }
</style>